import { Offer, NameBanner } from '@rumblefish/ui/Rumblefish23Theme';
import { SmartContractDevelopmentProcessData } from './SmartContractDevelopmentProcess.data';
import type { SmartContractDevelopmentProcessProps } from './SmartContractDevelopmentProcess.types';
import { StyledStack, StyledSection, SectionNameBannerStack } from './styles';

export const SmartContractDevelopmentProcess = ({
  ...props
}: SmartContractDevelopmentProcessProps): React.ReactElement => {
  const customThresholds = [0, 32, 54, 70, 90];

  return (
    <>
      <StyledSection width="normal" id="smart-contract-development-process">
        <StyledStack {...props}>
          <SectionNameBannerStack>
            <NameBanner
              type="section"
              text="Smart Contract Development Process"
              color="orange"
            />
          </SectionNameBannerStack>
        </StyledStack>
      </StyledSection>
      <Offer
        title={SmartContractDevelopmentProcessData.mainText}
        description={SmartContractDevelopmentProcessData.description}
        data={SmartContractDevelopmentProcessData.services}
        height={'240px'}
        thresholds={customThresholds}
      />
    </>
  );
};
